import { PopoverClose } from './PopoverClose'
import { PopoverRoot } from './PopoverRoot'
import { usePopover } from './usePopover'

export const Popover = {
  Root: PopoverRoot,
  Close: PopoverClose,
  store: usePopover,
}
